module.exports = __webpack_public_path__ + "img/cg_icon.9570b29.png";